/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_ConfiguredInputs */

const cs_sms_configured = /** @type {(inputs: Sms_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brána nastavena`)
};

const en_sms_configured = /** @type {(inputs: Sms_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gateway configured`)
};

/**
* | output |
* | --- |
* | "Gateway configured" |
*
* @param {Sms_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_configured = /** @type {((inputs?: Sms_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_configured(inputs)
	return cs_sms_configured(inputs)
});